import React, { useCallback, useEffect, useState } from 'react';
import { useControleAlerta } from '.';
import { Period } from '../Dashboard';
import PeriodItem from '../PeriodItem';
import styles from './PeriodosNaoContemplados.module.scss';
import { NotFoundMessage } from 'components/elements';

interface PeriodosNaoContempladosProps {
  periodosNaoContemplados: Period[];
  onPeriodosChange?: (novosPeríodos: Period[]) => void;
  onDataRefresh?: () => void;
}

const PeriodosNaoContemplados: React.FC<PeriodosNaoContempladosProps> = ({
  periodosNaoContemplados,
  onDataRefresh,
}) => {
  const { togglePeriodoSelecionado, loading, isPeriodoSelecionado } =
    useControleAlerta(onDataRefresh);
  const [periodosVisiveis, setPeriodosVisiveis] = useState<Period[]>([]);

  useEffect(() => {
    setPeriodosVisiveis(periodosNaoContemplados);
  }, [periodosNaoContemplados]);

  const handleTogglePeriodo = useCallback(
    (periodoId: string): boolean => {
      return togglePeriodoSelecionado(periodoId);
    },
    [togglePeriodoSelecionado]
  );

  if (periodosVisiveis.length === 0) {
    return <NotFoundMessage />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.periodsList}>
        {periodosVisiveis.map(periodo => (
          <PeriodItem
            key={periodo.id}
            periodo={periodo}
            onToggle={handleTogglePeriodo}
            loading={loading}
            isSelected={isPeriodoSelecionado(periodo.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default PeriodosNaoContemplados;
